import {type DesignerStores} from '@packages/systems/designer/flux';
import {AuthorizationResourceType} from '@packages/domains/identity-and-access/role-based-access/data-types';

type AuthorizationTests = Record<string, boolean>;
type AuthorizationOptions = {
  currentCollectionId?: string;
};

type StateSlice = Pick<
  DesignerStores,
  'AuthorizationsStore' | 'CurrentCollectionStore' | 'SiteDataStore'
>;

export const checkAuthorizations =
  (authorization: AuthorizationTests) =>
  (state: StateSlice, options?: AuthorizationOptions): boolean => {
    // TODO it seems bad that we allow by default
    const {userId} = state.SiteDataStore;
    if (!userId) {
      return true;
    }

    const userAuthorizations =
      state.AuthorizationsStore?.authorizations?.[userId];

    if (!userAuthorizations) {
      return true;
    }

    // assume all cases match until proven otherwise
    let outcomeMatcher = true;

    const authorizationEntries = Object.entries(authorization);

    for (const [resourceType, desiredBoolean] of authorizationEntries) {
      const resourcesOfType =
        userAuthorizations[resourceType as AuthorizationResourceType];
      const canAccessAllOfResource = !resourcesOfType;

      if (canAccessAllOfResource) {
        outcomeMatcher = desiredBoolean;
      } else if (resourceType === 'SiteCollection') {
        // check if collections exist on the auth.
        // if not, then they have full permisions
        if (!state.CurrentCollectionStore) {
          return true;
        }

        const currentCollection =
          state.CurrentCollectionStore.get('currentCollection');
        if (!currentCollection && !options?.currentCollectionId) {
          return true;
        }

        const resourceId =
          options?.currentCollectionId || currentCollection?._id;

        if (!resourceId) {
          return true;
        }

        const isRestricted = resourcesOfType[resourceId]?.isRestricted;
        outcomeMatcher = !isRestricted === desiredBoolean;
      }

      // short circuit on first mismatch
      if (!outcomeMatcher) {
        break;
      }
    }

    return outcomeMatcher;
  };
